var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.985,
    height: 13.8
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".video_svg__a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.8px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.9 .9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "video_svg__a",
    d: "M19.18 1.744l-6.1 4.36 6.1 4.36z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "video_svg__a",
    width: 13,
    height: 12,
    rx: 2
  }))));
}
export default __webpack_public_path__ + "static/media/video.38893321.svg";
export { SvgVideo as ReactComponent };